import cx from 'classnames'
import { ConvertableCommentTodoForm } from 'components/ConvertableCommentTodoForm/ConvertableCommentTodoForm'
import { TodoSubmitFn } from 'components/ConvertableCommentTodoForm/Types'
import { getHistoryInstance } from 'hooks/useHistory'
import { observer } from 'mobx-react-lite'
import { PRIORITY_EDITOR } from 'proseShared/constants'
import { EditorView } from 'prosemirror-view'
import Foco from 'react-foco'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import store from 'redux/store'
import { DocStore } from 'stores/DocStore'
import Styles from './CreateCommentPrompt.module.scss'
import { createCommentSubmit } from './createCommentSubmit'
import { ourUuid } from 'utils'

interface CommentPromptProps {
  view: EditorView
  close: () => void
  queryClient: QueryClient
  layerId: string
  richText: boolean
  docStore: DocStore
  onSubmitTodo?: TodoSubmitFn
  withPopoverStyles?: boolean
  overrideSelectionRange?: { from: number; to: number }
  id?: string
}

const PromptContent = observer(
  ({
    view,
    layerId,
    richText,
    onSubmitTodo,
    close,
    docStore,
    withPopoverStyles,
    overrideSelectionRange,
    id,
  }: CommentPromptProps) => {
    const convertableCommentTodoFormStyles = {
      commentFormWrapper: Styles.commentFormWrapper,
      commentForm: Styles.commentForm,
      commentInputContainer: Styles.commentInputContainer,
      commentInput: Styles.commentInput,
      todoFormWrapper: Styles.todoFormWrapper,
      todoForm: Styles.todoForm,
    }

    const onSubmitComment = createCommentSubmit(
      view,
      layerId,
      docStore,
      richText,
      ourUuid(),
      close,
      overrideSelectionRange,
    )

    return (
      <div
        id={id}
        className={cx(Styles.root, PRIORITY_EDITOR, { [Styles.popover]: withPopoverStyles })}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <ConvertableCommentTodoForm
          autoFocus
          hideActionsOnEmpty={false}
          docStore={docStore}
          onActiveChange={() => {}}
          placeholder="Write a comment"
          onSubmitComment={onSubmitComment}
          onSubmitTodo={onSubmitTodo}
          styles={convertableCommentTodoFormStyles}
          close={close}
        />
      </div>
    )
  },
)

export const CreateCommentPrompt = observer((props: CommentPromptProps) => {
  const handleCancel = () => {
    props.close()
  }

  return (
    <Router history={getHistoryInstance()}>
      <Foco onClickOutside={handleCancel}>
        <Provider store={store}>
          <QueryClientProvider client={props.queryClient}>
            <PromptContent {...props} />
          </QueryClientProvider>
        </Provider>
      </Foco>
    </Router>
  )
})
